export const Dot = () => (
  <span className="flex flex-none sm:w-2 sm:h-2 h-1.5 w-1.5 rounded-full bg-primary-400" />
);
